import React, { ReactElement, SyntheticEvent } from 'react'
import {
  formatQueryParams,
  getParameterByName,
  redirectToClientUrl,
  translate
} from 'helpers'
import { BackButton, Container, ErrorBody, Heading } from './subcomponents'
import ErrorMessage from './ErrorMessage'
import determinePersistResult from '../helpers/determinePersistResult'

interface PersistErrorProps {
  errorCode: number
  errorDescriptor?: string
}

const PersistError = ({
  errorCode,
  errorDescriptor
}: PersistErrorProps): ReactElement => {
  const qsParams = window.location.search
  const oauthRedirectUri = decodeURIComponent(
    getParameterByName('redirect_uri', qsParams)
  )
  const { clientError, clientErrorDescription } =
    determinePersistResult(errorCode)

  const handleBack = (e: SyntheticEvent): void => {
    e.preventDefault()
    const errRedirectUri = formatQueryParams(
      oauthRedirectUri,
      `error=${clientError}&error_description=${clientErrorDescription}`
    )
    redirectToClientUrl(errRedirectUri)
  }

  return (
    <Container>
      <ErrorBody>
        <Heading weight="bold">{translate({ string: 'weAreSorry' })}</Heading>
        <ErrorMessage errorCode={errorCode} errorDescriptor={errorDescriptor} />
        <BackButton
          buttonType="primary"
          onClick={handleBack}
          data-reason="login-not-permitted"
          data-type="back"
          data-object="button"
          className="ensightencustomevent"
        >
          Back
        </BackButton>
      </ErrorBody>
    </Container>
  )
}

export default PersistError
